import { render, staticRenderFns } from "./ModalFolder.vue?vue&type=template&id=08ac372e"
import script from "./ModalFolder.vue?vue&type=script&lang=js"
export * from "./ModalFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ac372e')) {
      api.createRecord('08ac372e', component.options)
    } else {
      api.reload('08ac372e', component.options)
    }
    module.hot.accept("./ModalFolder.vue?vue&type=template&id=08ac372e", function () {
      api.rerender('08ac372e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoDocuments/ModalFolder.vue"
export default component.exports